// apps/nos/client/src/services/food_api.ts
import axios from "axios";
import { serverURL } from "@/utils/serverURL";

type Headers = Record<string, string>;

export type CheckFoodNameResponse = {
  name: string;
  exists: boolean;
  foodId: number | null;
};

export async function checkFoodName(
  name: string,
  headers: Headers,
  signal?: AbortSignal,
): Promise<CheckFoodNameResponse> {
  const url = serverURL`/me/food/check-name`;
  const { data } = await axios.get<CheckFoodNameResponse>(url, {
    headers,
    params: { name },
    signal,
  });
  return data;
}
